import React, { useEffect, useState } from "react";
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import NewRegistrationModal from "components/Private/NewRegistrationModal";
import Swal from 'sweetalert2';
import EditGuestModal from "components/Private/EditGuestModal";
import { useGuestContext } from '../../contexts/GuestContext';
import Edit3R5PModal from "components/Private/Edit3R5PModal";
// react-bootstrap components
import {
    Button,
    Card,
    OverlayTrigger, Tooltip
} from "react-bootstrap";
import SheetUpload from "components/Private/SheetUpload";
// core components
import ReactTable from "../../components/ReactTable/ReactTable";

function Event3R5PTable() {
    const [refreshDataTrigger, setRefreshDataTrigger] = useState(0);
    const { language, setPageBanner, setLoading, viewingEvent, switchEvent, setViewingEvent } = useGuestContext();
    const [modal, setModal] = React.useState(false);
    const [uploadModal, setUploadModal] = React.useState(false);
    const [editGuestModal, setEditGuestModal] = React.useState(false);
    const [alert, setAlert] = React.useState(null);
    const [registrations, setRegistrations] = useState([]); // state for holding fetched data
    const [selectedRegistration, setSelectedRegistration] = useState(null);

    const hideAlert = () => {
        setAlert(null);
    };

    const handleEditClick = (guestId, response) => {
        console.log('Edit clicked for guest:', guestId);
        const registrationData = response.data.find(registration => registration.registration_id === guestId);

        setSelectedRegistration(registrationData);
        setEditGuestModal(!editGuestModal);
    };

    const handleResendNotificationClick = async (guestId) => {
        const url = `${process.env.REACT_APP_SERVER_URL}/event/resend-notification/${guestId}`;
        try {
            const response = await axios.post(url, {
                // Include any required data in the request body
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    // Include other headers as required, like authorization tokens
                }
            });
            // Handle response
            console.log('Notification resend successful', response.data);
            successNotificationResent(guestId)
            // You can process the response data as needed
        } catch (error) {
            // Handle errors from the request
            console.error('Error when trying to resend notification:', error.response ? error.response.data : error.message);
        }
    };

    const resendNotificationConfirm = (guestId) => {
        console.log('Resend notification clicked for guest:', guestId);
        // Handle the check-in logic
        const htmlContent = language === "English" ?
            `Are you sure you want to send the notification to <strong style="color: #007bff;">Registration ID: ${guestId}</strong>?` :
            `您確定要向 <strong style="color: #007bff;">Registration ID：${guestId}</strong> 發送通知嗎？`;

        Swal.fire({
            title: language === "English" ? "Send Notification" : "發送通知",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Yes, Send It" : "是的，發送",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                handleResendNotificationClick(guestId); // Call function to send notification
            } else {
                hideAlert(); // Hide the alert if cancelled
            }
        });
    };

    const handleCheckInClick = (guestId) => {
        console.log('Check-in clicked for guest:', guestId);
        // Confirmation SweetAlert
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to check-in Registration ID: ${guestId}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, check them in!'
        }).then((result) => {
            if (result.isConfirmed) {
                // Proceed with check-in API call if confirmed
                checkInGuest(guestId);
            }
        });
    };

    const checkInGuest = async (guestId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/event/3r5p/checkinconfirm?guestid=${guestId}`);
            // Handle successful check-in
            Swal.fire({
                title: 'Success!',
                text: `Registration ID: ${guestId} has been successfully checked in.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.reload(); // Reload the page to reflect changes
            });
        } catch (error) {
            // Handle error during check-in
            Swal.fire({
                title: 'Failed to Check-in',
                text: `There was a problem checking in Registration ID: ${guestId}. Please try again.`,
                icon: 'error',
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
            console.error('Check-in failed:', error);
        }
    };

    const handleReverseCheckInClick = (guestId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: `Do you want to revert the check-in for Registration ID: ${guestId}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, revert it!'
        }).then((result) => {
            if (result.isConfirmed) {
                reverseCheckInGuest(guestId);
            }
        });
    };

    const reverseCheckInGuest = async (guestId) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/event/3r5p/uncheckIn?guestid=${guestId}`);
            Swal.fire({
                title: 'Reversed!',
                text: `The check-in for Registration ID: ${guestId} has been reversed.`,
                icon: 'success',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            }).then(() => {
                window.location.reload(); // Reload the page to reflect changes
            });
        } catch (error) {
            Swal.fire({
                title: 'Failed to Reverse',
                text: `There was a problem reversing the check-in for Registration ID: ${guestId}. Please try again.`,
                icon: 'error',
                confirmButtonColor: '#d33',
                confirmButtonText: 'OK'
            });
            console.error('Reverse check-in failed:', error);
        }
    };

    const handleDeleteClick = (guestId) => {
        const htmlContent = language === "English" ?
            `Are you sure you would like to delete the registration of <strong style="color: #007bff;">Registration ID: ${guestId}</strong>?` :
            `您確定要刪除 <strong style="color: #007bff;">Registration ID：${guestId}</strong> 的報名嗎？`;

        Swal.fire({
            title: language === "English" ? "Delete Confirmation" : "確認要刪除嗎？",
            html: htmlContent,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: language === "English" ? "Confirm Deletion" : "確認刪除報名",
            cancelButtonText: language === "English" ? "Cancel" : "取消"
        }).then((result) => {
            if (result.isConfirmed) {
                deleteRegistration(guestId);
            } else {
                hideAlert();
            }
        });
    };

    const successNotificationResent = (guestId) => {
        const htmlContent = language === "English" ?
            `Email successfully sent to <strong style="color: #007bff;">Registration ID: ${guestId}</strong>.` :
            `已成功向 <strong style="color: #007bff;">Registration ID：${guestId}</strong> 發送電子郵件。`;

        Swal.fire({
            title: language === "English" ? "Email Sent!" : "電子郵件已發送！",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert(); // Hide the alert after acknowledging
        });
    };

    const successDelete = (guestId) => {
        const htmlContent = language === "English" ?
            `The registration of <strong style="color: #007bff;">Registration ID: ${guestId}</strong> is deleted.` :
            `<strong style="color: #007bff;">Registration ID：${guestId}</strong> 的報名已被刪除。`;
        Swal.fire({
            title: "Deleted!",
            html: htmlContent,
            icon: 'success',
            confirmButtonColor: '#17a2b8', // Using a color for the confirm button (Bootstrap's info color)
            confirmButtonText: language === "English" ? "OK" : "好的"
        }).then(() => {
            hideAlert();
        });
    };

    const deleteRegistration = async (guestId) => {
        try {
            setLoading(true); // Start loading (if you have a loading state)
            await axios.delete(`${process.env.REACT_APP_SERVER_URL}/event/3r5p/delete-registration/${guestId}`);
            successDelete(guestId);
            setLoading(false); // Stop loading (if you have a loading state)
            setRefreshDataTrigger(prev => prev + 1);
        } catch (error) {
            console.error('Error deleting registration:', error);
            setLoading(false); // Stop loading (if you have a loading state)
            // Handle error here, maybe show an error alert
        }
    }

    useEffect(() => {
        console.log(viewingEvent)
        const fetchRegistrations = async () => {
            try {
                setLoading(true); // If you have a loading state

                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/event/3r5p/getregistration`);
                const formattedData = response.data.map((registration) => {
                    // Conditional rendering for check-in / reverse check-in button
                    const checkInButton = registration.checkedIn && registration.checkedInTime ? (
                        <Button
                            size="sm"
                            className="btn-warning btn-link like"
                            onClick={() => handleReverseCheckInClick(registration.registration_id)}
                        >
                            <OverlayTrigger overlay={<Tooltip>Reverse Guest Check-in</Tooltip>}>
                                <FontAwesomeIcon icon={faCircleCheck} />
                            </OverlayTrigger>
                        </Button>
                    ) : (
                        <Button
                            size="sm"
                            className="text-success btn-link like"
                            onClick={() => handleCheckInClick(registration.registration_id)}
                        >
                            <OverlayTrigger overlay={<Tooltip>Check-in Guest</Tooltip>}>
                                <FontAwesomeIcon icon={faCircleCheck} />
                            </OverlayTrigger>
                        </Button>
                    );

                    return {
                        registration_id: String(registration.registration_id).padStart(4, '0'),
                        name: `${registration.firstname} ${registration.lastname}`,
                        email: registration.email,
                        phone: registration.phone,
                        // isVolunteering: registration.isVolunteering ? "Yes" : "No",
                        chineseName: registration.chinesename,
                        actions: (
                            <div className="actions-right">
                                <Button
                                    onClick={() => handleEditClick(registration.registration_id, response)}
                                    size="sm"
                                    className="text-warning btn-link edit"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}>
                                        <i className="fa fa-edit" />
                                    </OverlayTrigger>
                                </Button>{" "}
                                {/* <Button
                                    onClick={() => resendNotificationConfirm(registration.id)}
                                    size="sm"
                                    className="text-info btn-link like"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="resend-tooltip">Resend Notification</Tooltip>}>
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                    </OverlayTrigger>
                                </Button>{" "} */}
                                {checkInButton}
                                <Button
                                    onClick={() => handleDeleteClick(registration.registration_id)}
                                    variant="danger"
                                    size="sm"
                                    className="btn-link remove text-danger"
                                >
                                    <OverlayTrigger overlay={<Tooltip id="delete-tooltip">Delete Guest Registration</Tooltip>}>
                                        <i className="fa fa-times" />
                                    </OverlayTrigger>
                                </Button>{" "}
                            </div>
                        )
                    };
                });
                setRegistrations(formattedData);
                setLoading(false); // Stop loading indicator
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setLoading(false); // Stop loading indicator
            }
        };
        fetchRegistrations();
    }, [refreshDataTrigger, viewingEvent]);

    return (
        <>
            {alert}
            <Card.Body >
                <ReactTable
                    data={registrations}
                    columns={[
                        {
                            Header: "Registration ID",
                            accessor: "registration_id",
                        },
                        {
                            Header: "Full Name",
                            accessor: "name",
                        },
                        {
                            Header: "Chinese Name",
                            accessor: "chineseName",
                        },
                        {
                            Header: "Phone",
                            accessor: "phone",
                        },
                        {
                            Header: "Email",
                            accessor: "email",
                        },
                        {
                            Header: "Actions",
                            accessor: "actions",
                            sortable: false,
                            filterable: false,
                        },
                    ]}
                    className="-striped -highlight primary-pagination"
                />
            </Card.Body>

            <SheetUpload uploadModal={uploadModal} setUploadModal={setUploadModal} />
            <Edit3R5PModal editGuestModal={editGuestModal} setEditGuestModal={setEditGuestModal} registrationData={selectedRegistration} />
        </>
    );
}
export default Event3R5PTable;
